import React from "react"
import clsx from 'clsx'
import FolioBuilderWorkspace from './FolioBuilderWorkspace'

class FolioBuilderGeneral extends React.Component {
  constructor(props) {
    super(props)

  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true,
    });

    return(
  
      <div className={tabClasses} id="general">
        <FolioBuilderWorkspace {...this.props} edit={!this.props.folio_id ? false : true} />
      </div>
    )
  }

  renderFieldClasses(field) {
    var className = 'form-control';
    return className
  }
}

export default FolioBuilderGeneral